export {default as zoom} from "./src/zoom";
export {default as zoomTransform, identity as zoomIdentity} from "./src/transform";



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-zoom/index.js
// module id = 956
// module chunks = 0